import {
  ButtonBase,
  Container,
  delayedCall,
  dispatcher,
  // IEvent,
  ingenuity,
  // IObject,
  ITween,
  killDelayedCall,
  SpineBase,
} from "@quest/base-core";
import { JackpotOutroView } from "./JackpotOutroView";
import {
  ButtonBaseBehavior,
  MeterBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther";
import { Emitter } from "@quest/pixi-bridge/dist/Particles/Emitter";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { Linear } from "@quest/pixi-bridge/dist/easing/Easing";
import { GameParserModel } from "../../Platform/GameParserModel";
import { EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist";
import { gameConstants } from "../../Constants/gameConstants";

export class JackpotOutroController {
  private readonly view: JackpotOutroView;
  private jackpotBgContainer: Container;
  private jackpotFgContainer: Container;
  private jackpotOutroMainContainer: Container;
  private frontEmitter: Emitter;
  private backEmitter: Emitter;
  private jackpotBgSpine: SpineBase;
  private jackpotBgPortraitSpine: SpineBase;
  private jackpotfgSpine: SpineBase;

  private continueButton: ButtonBaseBehavior;

  private jackpotContinueButtonContainer: Container;

  constructor(view: JackpotOutroView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvent();
  }

  /**
   * method initializeElements: initialize elements to class components.
   */
  private initializeElements(): void {
    this.jackpotOutroMainContainer = this.view.getContainerByID("jackpotOutroMainContainer");
    this.jackpotBgContainer = this.view.getContainerByID("jackpotBgContainer");
    this.jackpotFgContainer = this.view.getContainerByID("jackpotFgContainer");
    this.continueButton = this.view.getButtonById("continueButton") as ButtonBaseBehavior;

    this.continueButton.on(ButtonBase.UP, this.onContinuePressUp, this);
    this.jackpotContinueButtonContainer = this.view.getContainerByID("jackpotContinueButtonContainer");
  }

  /**
   * Subscribe events
   */
  private subscribeEvent(): void {
    this.unSubscribeEvent();
    dispatcher.on(eventDispatchers.SHOW_JACKPOT_BANNER, this.onShowOutroBanner, this);
    // dispatcher.on(eventDispatchers.ADD_BANNER_ON_TOP, this.view.addOnTop, this.view);
  }
  /**
   * Unsubscribe events
  */
 private unSubscribeEvent(): void {
   dispatcher.off(eventDispatchers.SHOW_JACKPOT_BANNER, this.onShowOutroBanner, this);
  //  dispatcher.off(eventDispatchers.ADD_BANNER_ON_TOP, this.view.addOnTop, this.view);
  }

  /**
   * start outro spine
   */
  private onShowOutroBanner(): void {
    this.jackpotOutroMainContainer.visible = true;
    this.continueButton.disableAndTint();
    this.initializeSpine();
    this.playJpBannerAnim();
  }
  /**
   * play jp outro spiine anim and coin shower
   */
  private playJpBannerAnim(): void {
    this.jackpotBgSpine.setPause(false);
    this.jackpotfgSpine.setPause(false);

    this.jackpotBgSpine.visible = true;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.jackpotBgPortraitSpine.setPause(false);
      this.jackpotBgPortraitSpine.visible = true;
      this.jackpotBgPortraitSpine.playAnim("bg_portrait_intro", false);
    }
    this.jackpotBgSpine.playAnim(`bg_intro`, false);
    delayedCall("CharacterSpinePlayDelay", 1000, () => {
      killDelayedCall("CharacterSpinePlayDelay");
      dispatcher.fireEvent(eventDispatchers.STOP_JP_BUBBLES);

      this.jackpotfgSpine.mask = this.view.getShapeById("JPMask");

      this.startJackpotOutroTickup((ingenuity.parserModel as GameParserModel).getJackpotAmt());
    });
    this.jackpotfgSpine.visible = true;
    this.jackpotfgSpine.playAnim(`intro`, false);
    delayedCall("coinExplodeDelay", 400, () => {
      this.startExplodeCoinAnim();
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.JACKPOT_BLUR_BG);

    })
    this.jackpotfgSpine.onComplete.addOnce(() => {
      this.jackpotContinueButtonContainer.visible = true;

      this.jackpotfgSpine.playAnim(`idle`, true);
      this.jackpotBgSpine.playAnim(`bg_idle`, true);
      this.jackpotBgPortraitSpine?.playAnim("bg_portrait_idle", true);
      this.playRearCoinShower();
    });
  }

  /**
   * initialize spines
   */
  private initializeSpine(): void {
    this.jackpotBgSpine = this.jackpotBgContainer.getChildByName("jackpot_whale_outro_bg") as SpineBase;
    this.jackpotfgSpine = this.jackpotFgContainer.getChildByName("jackpot_whale_outro") as SpineBase;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.jackpotBgPortraitSpine = this.view.getSpineById("jackpot_whale_outro_bg_port");
    }
  }

  // Add to play coin shower
  private playRearCoinShower(): void {
    this.initializeCoinShowerEmitter();
    this.startCoinShowerEmitter();
  }

  /**
   * Initialize Data for Coin Shower Emmiter
   */
  private initializeCoinShowerEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.8,
        end: 1.2,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 200,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.01,
      emitterLifetime: -1,
      maxParticles: 1500,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("jackpotRearCoinBlastContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
  }

  /**
   * function to initiate coin shower
   */
  private startCoinShowerEmitter(): void {
    this.backEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
    this.backEmitter.autoUpdate = true;
    this.backEmitter.emit = true;
  }

  /**
   * This method starts the coin shower animation
   */
  private startExplodeCoinAnim(): void {
    this.initializeCoinExplodeEmitter();
    this.startCoinExplodeEmitter();
  }

  /**
   * Initialize Data for Coin Explode Emmiter
   */
  private initializeCoinExplodeEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinfrontEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 30,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 1,
        end: 1.47,
        minimumScaleMultiplier: 1,
      },
      speed: {
        start: 300,
        end: 500,
        minimumSpeedMultiplier: 4,
      },
      acceleration: {
        x: 0,
        y: 750,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 10,
      },
      lifetime: {
        min: 5,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.001,
      emitterLifetime: 1,
      maxParticles: 100,
      pos: {
        x: 0,
        y: 50,
      },
      addAtBack: true,
      spawnType: "burst",
      particlesPerWave: 10,
      particleSpacing: 0,
      angleStart: 0,
    };
    const coinShowerContainer1: Container = this.view.getContainerByID("jackpotfrontCoinBlastContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer1, particleData, config) as Emitter;
  }

  /**
   * This method start the second emitter
   * @returns
   */
  private startCoinExplodeEmitter(): void {
    this.frontEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinfrontEmitter");
    this.frontEmitter.autoUpdate = true;
    this.frontEmitter.emit = true;
  }

  /**
   * function to start outro tickup
   */
  private startJackpotOutroTickup(amount: number): void {
    const jackpotWinMeter = this.view.getMeterById("OutroWinAmount") as MeterBehavior;
    this.view.getImageById("coin_image").visible = true;
    jackpotWinMeter.setValue(0)
    jackpotWinMeter.visible = true;
    this.view.getContainerByID("taptoclickMessage").alpha = 0.7;
    this.view.getContainerByID("taptoclickMessage").visible = true;
    this.continueButton.disableAndTint();
    jackpotWinMeter.startTick(amount, true, false, 1.5, true, () => {
      this.continueButton.enableAndTint();
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
    });
  }

  /**to handle continue pressup action */
  private onContinuePressUp(): void {
    this.continueButton.disableAndTint();
    this.hidePlayerMessage();
    if (this.backEmitter) {
      this.backEmitter.destroy();
      this.backEmitter.emit = false;
    }
    this.jackpotOutroPresentationComplete();
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, { value: (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getJackpotAmt() });
    this.view.getMeterById(`OutroWinAmount`).visible = false;
    this.view.getImageById(`coin_image`).visible = false;
  }
  /**
   * function will hide player msg
   */
  private hidePlayerMessage(): void {
    const alphaTween: ITween = ingenuity.currentGame.add
      .tween(this.view.getContainerByID("taptoclickMessage"))
      .to({ alpha: 0 }, 300, Linear.None, true, 0, 0, false);
    alphaTween.onComplete.addOnce(() => {
      dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_BANNER);
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
      this.view.getContainerByID("taptoclickMessage").visible = false;
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
      alphaTween.stop();
      ingenuity.currentGame.tweens.remove(alphaTween);
    }, this);
  }

  /**
   * play jackpot outro spine
   */
  private jackpotOutroPresentationComplete(): void {
    const animateJackpotBg = new Promise<void>((resolve) => {
      this.jackpotBgSpine.playAnim(`bg_outro`, false);
      this.jackpotBgPortraitSpine?.playAnim("bg_portrait_outro", false)
      this.jackpotBgSpine.onComplete.addOnce(() => {
        this.jackpotBgSpine.visible = false;
        if (!ingenuity.deviceEnv.isDesktop) {
          this.jackpotBgPortraitSpine.visible = false;
        }
        resolve();
        dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);

      });
    });
    const animateJackpotFg = new Promise<void>((resolve) => {
      this.jackpotfgSpine.playAnim(`outro`, false);
      this.jackpotfgSpine.onComplete.addOnce(() => {
        this.jackpotfgSpine.visible = false;
        resolve();
      });
    });
    Promise.all([animateJackpotBg, animateJackpotFg])
      .then(() => {
        this.resetFeature();
      })
      .catch((error) => {
        console.error("Error with animations:", error);
      });
  }

  /**
   * reset function
   */
  private resetFeature(): void {
    this.jackpotfgSpine.mask = null
    this.view.getMeterById(`OutroWinAmount`).setValue(0);
    this.jackpotOutroMainContainer.visible = false;

    this.frontEmitter.destroy();
    this.frontEmitter.emit = false;

    this.jackpotBgSpine.setPause(true);
    this.jackpotfgSpine.setPause(true);

    this.jackpotBgSpine = null;
    this.jackpotBgPortraitSpine = null;
    this.jackpotfgSpine = null;

    this.view.getContainerByID("jackpotRearCoinBlastContainer").removeChildren();
    this.view.getContainerByID("jackpotfrontCoinBlastContainer").removeChildren();

    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN);
  }
}
